$(document).ready(function() {
	if(!document.getElementById('inquirytoBuyForm')) return false;

	var inquiryToBuyCaptcha = {
		el: document.getElementById('inquirytoBuyForm'),
		validation: function(){
			var url = inquiryToBuyCaptcha.el.getAttribute('data-captcha-url');
			var param = {
				LBD_VCID_customizedCaptcha: $("#LBD_VCID_customizedCaptcha").val(),
				getInstanceId: $("#getInstanceId").val(),
				getCodeCollection: $("#getCodeCollection").val(),
				captchaCodeTextBox: $("#captchaCodeTextBox").val(),
				reCaptchaToken: $('#reCaptchaToken').val()
			};
			var productCategory = inquiryToBuyCaptcha.el.querySelector('input[name="productCategory"]');
			if(productCategory) {
				param.productCategory = productCategory.value;
			}
			var result = true;
			$.ajax({
				type: 'post',
				url: url,
				async: false,
				dataType: 'json',
				data: param,
				success: function(data) {
					if(data.result == false) {
						$(inquiryToBuyCaptcha.el).find('.custom-field-block').addClass('error');
						$(inquiryToBuyCaptcha.el).find('.custom-error-msg .ajax-msg').text(data.errorMsg).show().siblings().hide();
						result = data.result;
					}else if(data.result != false) {
						$(inquiryToBuyCaptcha.el).find('.custom-field-block').removeClass('error');
						result = data;
					}
				
				},
				error: function(request,status,error) {
					console.log("status: "+status);
					console.log("error: "+error);
					result = false;
				}
			});

			return result;
		},
		addEvent: function(){
			$(inquiryToBuyCaptcha.el).on({
				keydown: function(e){
					if(e.keyCode==13) {
						if(!inquiryToBuyCaptcha.validation()) {
							return false;
						}
					}
				}
			}, 'input');
		}
	};
	
	var iq = {
		el: document.getElementById('inquirytoBuyForm'),
		target: document.getElementById('appendTarget'),
		init: function(){
			$(iq.el.selectProductCategory).on({
				change: function(e){
					var _this = e.currentTarget;
					
					/* LGEGMC-144 20200408 add */
					iq.setAdobeValueAttr($(_this));
					/*//LGEGMC-144 20200408 add */

					/*DC-3443 Start */
					var label = _this.options[_this.selectedIndex].label;
					dataLayer.push({"event":"lgBusinessEvent","category":"business - inquiry to buy","action":"Product Category Menu", "label":label,"businessUnit":"b2b", "componentID": "n/a"});
					/* DC-3443 End */
					
					var url = _this.options[_this.selectedIndex].getAttribute('data-url');
					ajax.call(url, {}, 'html', function(data){
						if(data) {
							$(iq.target).html(data);
							var captchaBox = document.getElementById('customizedCaptcha');
							var captchaCate = $(captchaBox).find('input[name="productCategory"]');
							var myvalue = xssfilter(_this.value);
							if(captchaCate.get(0)) {
								captchaCate.val(myvalue);
							}else {
								$(captchaBox).prepend('<input type="hidden" name="productCategory" value="'+myvalue+'">');
							}
							runChosen();
							chosenScrollInit();

							if($(iq.target).find('textarea[maxlength]').length) {
								var obj = $(iq.target).find('textarea[maxlength]');
								checkTextLength(obj, obj.parent().find('.left-text .count'));
							}
						}
					});
				}
			});
			$(iq.el).on({
				validationSuccess: function(e){
					e.preventDefault();
					
					grecaptcha.enterprise.execute($("#sitKey").val(), {action: 'inquirytoBuy'}).then(function(token) {
						$('#reCaptchaToken').val(token);
						
						//var result = captcha.validation();
						var result = inquiryToBuyCaptcha.validation();
						if(result) {
							var noReturnFlag = result.noReturnFlag && result.noReturnFlag == "Y";
							var url = result.url && (result.url != '' && result.url != null);
							/* 20191031 : LGEUS-12240 add */ 
							$(".cmpid").val(document.location.href);
							var param = xssfilter($(iq.el).serialize());
							if(noReturnFlag && url) { 
								$.ajax({
									url: result.url,
									type: 'POST',
									data: param,
									timeout: 3000,
									success: function (result) {
									},
						            error: function (e) {
										// alert(e);
						            },
						            complete:function(f){
										setTimeout(function() {
											e.currentTarget.submit(); 
										}, 2000);
						            }
								});
								// $(iq.el).find('fieldset').hide();
								// $(iq.el).find('.product-category').hide();
								// $(iq.el).find('.complete-wrap').show();
								
								// $('html, body').stop().delay(100).animate({ scrollTop: 0 }, 500);
								/* 20191031 : LGEUS-12240 end */ 
	
							} else {
							 	e.currentTarget.submit();
							 }
							/*//20191031 : LGEUS-12240 add */ 
						}
					});
				},
				validationFail: function(e){
					e.preventDefault();
				},
				submit: function(e){
					e.preventDefault();
				},
				/* LGEGMC-144 20200408 add */
				change: function(e){
					if (/(productSolution|inquiryType)/.test(e.target.name)) {
						iq.setAdobeValueAttr($(e.target));
					}
				}
				/* //LGEGMC-144 20200408 add */
			});
			
			// when loading a page, the category is already selected.
			if($(iq.el.selectProductCategory).find('option[selected]').index() != 0) {
				$(iq.el.selectProductCategory).trigger('change');
			}
		},
		/* LGEGMC-144 20200423 add */
		setAdobeValueAttr: function($target) {
			var val = $.trim($target.val());
			var tit = val ? $.trim($target.find('option:selected').text()) : '';
			$target.attr('adobe-value',tit);

			if (val) {
				var paramMap = {
					selectProductCategory:  'inquiry_to_buy_product_category_select',
					productSolution:		'inquiry_to_buy_product_solution_select',
					inquiryType:			'inquiry_to_buy_inquiry_type_select'
				};

				var paramName = paramMap[$target[0].name];
				var param = {};
				param.page_event = {};

				param[paramName] = tit;
				param.page_event[paramName] = true;
				adobeTrackEvent(paramName, param);
			}
		}
		/*//LGEGMC-144 20200423 add */
	};

	iq.init();

	$('#appendTarget').on('input mouseup mouseenter', 'input, textarea', function() {
		var $this = $(this);
		$this.val(xssfilter($this.val(), 'form'));
	});
});